import React from 'react'

import { EntitySearch } from 'components/ui/entity-search'
import { IconList } from 'components/ui/icons'
import { Description, IdentifyingText, Image, Title, ListItemLabel, Subtitle } from 'components/ui/list-item-label'
import { RadioInputElement } from 'components/ui/radio'

import { connect } from 'containers/store'

import { ListTMSObjectsRequest, TMSObject } from 'generated/mos/org/getty/integrationtms'
import { Media } from 'generated/mos/media'


import { bffEndpoint } from 'helpers/bff'
import { pick } from 'helpers/core'

import { actionCreators, GettyActionCreators } from '../../../actions'
import { GettyStore } from '../../../store'


type ConnectedProps = {
  readonly tmsObjectList: GettyStore['getty']['tmsObjectList'];
};

type ActionProps = Pick<GettyActionCreators, 'gettyListTMSObjectsRequest'>;

type DirectProps = {
  readonly tmsObjectSelected: any;
  readonly onUpdate: (details: TMSObject.Entity | undefined) => void;
};

type Props = ConnectedProps & ActionProps & DirectProps;

const SelectTmsObjectView = (props: Props) => {
  const { gettyListTMSObjectsRequest, tmsObjectList, tmsObjectSelected, onUpdate } = props

  const onToggleEntity = (entity: TMSObject.Entity) => {
    const selectedRef = tmsObjectSelected && TMSObject.isRef(tmsObjectSelected.ref) ? tmsObjectSelected.ref.id : undefined

    // it's currently selected, so unselect it.
    if (selectedRef && selectedRef === TMSObject.mustRef(entity.ref).id) {
      onUpdate(TMSObject.defaults)
    }
    // update the parent with the entity which has been selected.
    else {
      onUpdate(entity)
    }
  }

  const hostName = bffEndpoint(window.location.hostname)

  const listItem = (entity: TMSObject.Entity) => {
    const selected =
      tmsObjectSelected &&
      tmsObjectSelected.ref &&
      TMSObject.mustRef(tmsObjectSelected.ref).id === TMSObject.mustRef(entity.ref).id

    const mediaId = entity.imageMediaRef && entity.imageMediaRef.id
    const imagePath = mediaId ? `${hostName}/images/${mediaId}.jpg?s=crop&h=112&w=112` : ''

    return (
      <ListItemLabel key={TMSObject.mustRef(entity.ref).id}>
        <RadioInputElement
          checked={selected}
          name={TMSObject.mustRef(entity.ref).id}
          onChange={() => onToggleEntity(entity)}
        />
        <Image src={imagePath} />
        <Description>
          <Title>{entity.primaryTitle}</Title>
          {entity.producedBy && (<Subtitle>{entity.producedBy}</Subtitle>)}
        </Description>
        {entity.tmsId &&(<IdentifyingText>{entity.tmsId}</IdentifyingText>)}
      </ListItemLabel>
    )
  }

  const renderEntityStyles = [
    {
      icon: IconList,
      name: 'list',
      render: listItem,
    },
  ]

  return (
    <EntitySearch
      entityList={tmsObjectList}
      onSearch={() => onUpdate(undefined)}
      renderEntityStyles={renderEntityStyles}
      requestRefType={ListTMSObjectsRequest.refName}
      sortOrder="SORT_MODIFIED_DESC"
      triggerRequest={gettyListTMSObjectsRequest}
    />
  )
}

export const SelectTmsObject = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  store => ({ tmsObjectList: store.getty.tmsObjectList }),
  pick(actionCreators, 'gettyListTMSObjectsRequest')
)(SelectTmsObjectView)
